import { Model } from '@vuex-orm/core'
import MZLocation from './MZLocation'
import MZLocationable from './MZLocationable'

export default class MZLoyalty extends Model {
  static entity = 'mzloyalties'
  static primaryKey = 'id'

  static fields () {
    return {
      id: this.string(''),
      account_id: this.string(''),
      directory_list_loyalty: this.string(''),
      name: this.string(''),
      type: this.string(''),
      interval_add_time_limit: this.attr(''),
      unit: this.string(''),
      aggregator: this.string(''),
      reward_threshold: this.attr(''),
      user_unit_count: this.attr(''),
      rewardable_image: this.attr(''),
      image: this.attr(''),
      locations: this.morphToMany(MZLocation, MZLocationable, 'location_id', 'locationable_id', 'locationable_type')
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/MZLoyalty.js